import './App.css';
import { Routing } from "./appRoutes";
// import { Leva } from "leva";
// import ConfiguratorViewer from './components/ConfiguratorViewer/ConfiguratorViewer'

function App() {
  return (
      <>
        <Routing />
      </>
  );
}

export default App;
